module.exports = __webpack_public_path__ + "img/Roundworm.40cda91a.png";